import React, { Component } from 'react';
import { Button, Modal, Input } from 'antd';
import styles from './edit-password-modal.module.sass';
import { STATUS } from '../../../../redux/constants';
import {
  showNotification,
  simpleErrorNotification,
} from '../../../../shared-components/Notifications';

// const STEPS = {
//   METHOD: 'METHOD',
//   QR_CODE: 'QR_CODE',
//   PIN_CODE: 'PIN_CODE',
//   BACKUP_CODES: 'BACKUP_CODES',
//   DONE: 'DONE',
// };

class EditPasswordModal extends Component {
  state = {
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
    showError: false,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.status !== STATUS.ERROR &&
      this.props.status === STATUS.ERROR
    ) {
      this.setState({ showError: true });
    }
  }

  handleOldPasswordChange = (e) => {
    this.setState({ oldPassword: e.target.value });
  };

  handleNewPasswordChange = (e) => {
    this.setState({ newPassword: e.target.value });
  };

  handleConfirmNewPasswordChange = (e) => {
    this.setState({ confirmNewPassword: e.target.value });
  };

  handleSubmit = () => {
    const { oldPassword, newPassword, confirmNewPassword } = this.state;

    // if (newPassword !== confirmNewPassword) {
    //   return showErrorMessage({
    //     content: 'An error has occured, wrong new password.',
    //   })
    // }
    if (!oldPassword || !newPassword || !confirmNewPassword) {
      showNotification(
        simpleErrorNotification({
          // statusCode: 400,
          message: 'Please enter a password.',
        }),
      );
    }

    if (oldPassword && newPassword && confirmNewPassword) {
      this.props.onCancel();
      this.props.changePassword({
        oldPassword,
        newPassword,
        confirmNewPassword,
      });
    }
  };

  render() {
    const { oldPassword, newPassword, confirmNewPassword } = this.state;

    return (
      <Modal
        title="Change your password"
        className={styles.container}
        visible
        onCancel={this.props.onCancel}
        footer={[
          <Button key="cancel" onClick={this.props.onCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={this.handleSubmit}>
            Save
          </Button>,
        ]}
      >
        <div className={styles.password_container}>
          <div className={styles.password_label}>Old Password</div>
          <div className={styles.password_input_field}>
            <Input
              data-testid={'input1001'}
              type="password"
              value={oldPassword}
              onChange={(e) => this.handleOldPasswordChange(e)}
            ></Input>
          </div>
          <div className={styles.password_label}>New password</div>
          <div className={styles.password_input_field}>
            <Input
              data-testid={'input1002'}
              type="password"
              onChange={(e) => this.handleNewPasswordChange(e)}
            ></Input>
          </div>
          <div className={styles.password_label}>Confirm new password</div>
          <div className={styles.password_input_field}>
            <Input
              data-testid={'input1003'}
              type="password"
              onChange={(e) =>
                this.handleConfirmNewPasswordChange(e, 'password')
              }
            ></Input>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EditPasswordModal;
